import React from 'react';
import getChildRoutes from './childRoutes';
import App from './../App';
import LazyUniversalComponent from 'Components/LazyUniversalComponent/LazyUniversalComponent';
import { onEnterApp, onChangeApp } from './legacyRouterHooks';
import ErrorScreen from '../autos/Inspection/Booking/Components/ErrorScreen/ErrorScreen';

const routes = config => {
    return [{
        path: '/',
        element: <LazyUniversalComponent
            component={ App }
            onEnter={ onEnterApp }
            onChange={ onChangeApp }
        />,
        unsafeOnEnter: onEnterApp,
        errorElement: <ErrorScreen />,
        children: getChildRoutes(config)
    }];
};

export default routes;
